import React from 'react';
import { css } from 'emotion';
import { from } from '@guardian/src-foundations/mq';
import { border, labs, space } from '@guardian/src-foundations';
import { Dropdown } from '@root/src/web/components/Dropdown';
import LabsLogo from '@frontend/static/logos/the-guardian-labs.svg';
import { textSans } from '@guardian/src-foundations/typography';
import { LinkButton } from '@guardian/src-button';
import { SvgArrowRightStraight } from '@guardian/src-icons';
import { Link } from '@guardian/src-link';
const Container = ({ children }) => (React.createElement("div", { className: css `
			position: relative;
			height: 55px;
			display: flex;
			justify-content: space-between;
		` }, children));
const Left = ({ children }) => (React.createElement("div", { className: css `
			display: flex;
		` }, children));
const Right = ({ children }) => (React.createElement("div", { className: css `
			display: flex;
			padding: ${space[1]}px 0;
		` }, children));
const HeaderSection = ({ children, isFirst, }) => (React.createElement("div", { className: css `
			border-right: 1px solid ${border.primary};
			height: 100%;
			display: flex;
			align-items: center;

			${isFirst ? null : 'padding-left: 10px;'}
			padding-right: 10px;
			${from.mobileLandscape} {
				${isFirst ? null : 'padding-left: 20px;'}
				padding-right: 20px;
			}
		` }, children));
const Title = () => (React.createElement("div", { className: css `
			${textSans.small({ fontWeight: 'bold' })};
			margin-bottom: 4px;
		` }, "Paid content"));
const AboutDropdown = ({ children }) => (React.createElement("div", { className: css `
			color: black;
			> button {
				${textSans.small()};
				color: black;
				:hover {
					color: black;
				}
			}
		` }, children));
const About = () => (React.createElement("div", { className: css `
			${textSans.small()};
			position: absolute;
			top: 55px;
			left: 0;
			background-color: ${labs[400]};
			border-top: 1px solid ${border.primary};

			width: 100vw;
			${from.desktop} {
				width: 235px;
			}

			margin-left: -10px;
			${from.mobileLandscape} {
				margin-left: -20px;
			}
			padding: ${space[2]}px 10px;
			${from.mobileLandscape} {
				padding: ${space[3]}px 20px;
			}

			> a {
				color: black;
			}
		` },
    React.createElement("p", null, "Paid content is paid for and controlled by an advertiser and produced by the Guardian Labs team."),
    React.createElement("br", null),
    React.createElement(LinkButton, { iconSide: "right", size: "xsmall", priority: "subdued", icon: React.createElement(SvgArrowRightStraight, null), href: "https://www.theguardian.com/info/2016/jan/25/content-funding" }, "Learn more")));
const Logo = () => (React.createElement(Link, { href: "https://www.theguardian.com/guardian-labs" },
    React.createElement(LabsLogo, null)));
export const LabsHeader = () => (React.createElement(Container, null,
    React.createElement(Left, null,
        React.createElement(HeaderSection, { isFirst: true },
            React.createElement(Title, null)),
        React.createElement(HeaderSection, null,
            React.createElement(AboutDropdown, null,
                React.createElement(Dropdown, { label: "About", links: [], id: "paidfor", overrideColor: "black", dataLinkName: "" },
                    React.createElement(About, null))))),
    React.createElement(Right, null,
        React.createElement(Logo, null))));
